import React from 'react'
import PropTypes from 'prop-types'
import './style.sass'

const IconTitle = ({ icon, title, iconClass }) => {
  if (!icon && !title) return null
  return (
    <div className="icon-title">
      <label>
        {icon && <i className={`fa fa-${icon} ${iconClass}`} />}
        {title}
      </label>
    </div>
  )
}

IconTitle.propTypes = {
  icon: PropTypes.string,
  title: PropTypes.string.isRequired,
  iconClass: PropTypes.oneOf(['icon-primary', 'icon-success', 'icon-warning', 'icon-error'])
}

export default IconTitle
